import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import Switch from '@ui/switch/switch';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
import { ICONS } from '@ui/icons/types';
import type React from 'react';
import type { CSSProperties } from 'react';
import { TooltipPortalContentDirection } from '@ui/tooltip-portal/tooltip-portal-types';
import IconWithBackdrop from '@ui/icons/icon-with-backdrop';

interface ToggleProps {
  label?: string;
  value: boolean;
  sKey: string;
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  onToggle: (val: string, on: boolean) => void;
  onLabel?: string;
  offLabel?: string;
  padding?: string;
  children?: React.ReactNode;
  tooltipText?: string;
  gap?: CSSProperties['gap'];
  switchTooltipText?: string;
}

const SettingsToggle = ({
  label,
  value,
  sKey,
  disabled = false,
  fullWidth = false,
  onToggle,
  padding = '16px',
  loading = false,
  children,
  tooltipText,
  gap = '16px',
  switchTooltipText,
}: ToggleProps) => {
  return (
    <Container
      padding={padding}
      background="var(--gray-900)"
      borderRadius="12px"
      width={fullWidth ? '100%' : 'auto'}
      className={`flex flex-column`}
      gap={gap}
      loading={loading}
      data-component="SettingsToggle"
    >
      <Container className={`flex ${fullWidth ? 'fd-row' : 'ai-center jc-space-between'}`}>
        <Container className="flex gap-4 ai-center">
          {!fullWidth && (
            <Text tag="h6" className="H6">
              {label}
            </Text>
          )}
          {tooltipText && (
            <TooltipPortal
              childrenWrapperClass="flex"
              tooltipContent={
                <Text design="GlobalIcoText1" className="P2" maxWidth="250px">
                  {tooltipText}
                </Text>
              }
            >
              <IconWithBackdrop
                name={ICONS.INFO_CIRCLE}
                size={12}
                color="var(--primitives-mode-1-gray-500)"
                backdropColor="var(--primitives-mode-1-gray-100)"
              />
            </TooltipPortal>
          )}
        </Container>
        <div
          style={{
            flex: fullWidth ? 1 : 'unset',
            display: fullWidth ? 'flex' : 'block',
            marginTop: 'auto',
            height: '20px',
          }}
        >
          <TooltipPortal
            disabled={!switchTooltipText}
            childrenWrapperClass="flex"
            verticalOffset={-4}
            contentDirection={TooltipPortalContentDirection.RTL}
            keepOpenOnContentHover={false}
            tooltipContent={
              <Text design="GlobalIcoText1" className="P2" maxWidth="250px">
                {switchTooltipText}
              </Text>
            }
          >
            <Switch on={value || false} onClick={onToggle} value={sKey} disabled={disabled} />
          </TooltipPortal>
        </div>
      </Container>
      {children}
    </Container>
  );
};

export default SettingsToggle;
